{
  "common": {
    "loading": "Загрузка...",
    "not_found": "Не найдено",
    "back": "← Назад",
    "add_to_cart": "В корзину",
    "added": "Добавлено ✓",
    "remove": "Удалить",
    "save": "Сохранить",
    "cancel": "Отмена",
    "confirm": "Подтвердить",
    "search": "Поиск",
    "clear": "Очистить",
    "error": "Ошибка",
    "yes": "Да",
    "no": "Нет"
  },
  "nav": {
    "home": "Главная",
    "favorites": "Избранное",
    "cart": "Корзина",
    "profile": "Профиль"
  },
  "cart": {
    "title": "Корзина",
    "empty": "Пока пусто.",
    "empty_hint": "Добавьте товары из каталога",
    "go_to_catalog": "Перейти в каталог",
    "size_word": "размер",
    "increase": "Увеличить",
    "decrease": "Уменьшить"
  },
  "favorites": {
    "title": "Избранное",
    "empty": "Пока пусто.",
    "empty_hint": "Добавьте товары, чтобы вернуться к ним позже",
    "go_to_catalog": "Перейти в каталог",
    "recommendations": "Вам может понравиться",
    "aria_add": "В избранное",
    "aria_remove": "Убрать из избранного"
  },
  "product": {
    "not_found": "Товар не найден",
    "article": "Артикул",
    "country": "Страна",
    "composition": "Состав",
    "color": "Цвет",
    "size": "Размер",
    "stock": "Остаток: {count} шт.",
    "description": "Описание",
    "view_image": "Фото {n}",
    "delivery_estimate": "Доставка 7–14 дней"
  },
  "badges": {
    "original": "Оригинал",
    "in-stock": "В наличии",
    "new": "Новинка",
    "hit": "Хит",
    "sale": "Распродажа",
    "exclusive": "Эксклюзив"
  },
  "catalog": {
    "search_placeholder": "Поиск по каталогу",
    "all": "Все",
    "category": "Категория",
    "brand": "Бренд",
    "color": "Цвет",
    "size": "Размер",
    "sort": "Сортировка",
    "sort_newest": "Сначала новые",
    "sort_price_asc": "Сначала дешёвые",
    "sort_price_desc": "Сначала дорогие",
    "all_categories": "Все категории",
    "all_brands": "Все бренды",
    "all_colors": "Все цвета",
    "all_sizes": "Все размеры",
    "empty": "Ничего не найдено",
    "error": "Ошибка загрузки каталога",
    "count": "{count} товаров",
    "all_products": "Все товары",
    "in_stock": "В наличии",
    "foreign": "Оригинал",
    "filter": "Фильтр",
    "reset_filters": "Сбросить фильтры"
  },
  "admin": {
    "title": "Админ-панель",
    "no_access": "Нет доступа",
    "add": "Добавить",
    "edit": "Изменить",
    "save": "Сохранить",
    "delete": "Удалить",
    "ban": "Заблокировать",
    "unban": "Разблокировать",
    "saved": "Сохранено",
    "deleted": "Удалено",
    "empty": "Пусто",
    "on": "Вкл",
    "off": "Выкл",
    "f_title": "Заголовок",
    "f_subtitle": "Подзаголовок",
    "f_image": "Ссылка на фото",
    "f_position": "Позиция",
    "f_active": "Активен",
    "f_name": "Название",
    "f_address": "Адрес",
    "f_city": "Город",
    "f_phone": "Телефон",
    "f_lat": "Широта",
    "f_lng": "Долгота",
    "f_slug": "Slug",
    "f_main": "Главный",
    "f_sort": "Сортировка",
    "f_kind": "Тип",
    "dict_size": "Размеры",
    "dict_color": "Цвета",
    "dict_brand": "Бренды",
    "dict_badge": "Бейджи",
    "f_hex": "Цвет (hex)",
    "f_article": "Артикул",
    "f_price": "Цена",
    "f_oldprice": "Старая цена",
    "f_badge": "Бейдж",
    "f_status": "Статус",
    "a_orders": "Заказов",
    "a_revenue": "Выручка",
    "a_users": "Пользователей",
    "a_products": "Товаров",
    "a_visits": "Визитов",
    "a_by_status": "По статусам",
    "sec_orders": "Заказы",
    "sec_catalog": "Каталог",
    "sec_marketing": "Маркетинг",
    "sec_system": "Система",
    "mod_orders": "Заказы",
    "mod_orders_hint": "Все заказы и смена статуса",
    "mod_returns": "Возвраты",
    "mod_returns_hint": "Заявки на возврат товара",
    "mod_promotions": "Промо-акции",
    "mod_promotions_hint": "Скидки и бонусы",
    "mod_campaigns": "Рассылки",
    "mod_campaigns_hint": "Новости и акции клиентам",
    "camp_new": "+ Новая рассылка",
    "camp_empty": "Рассылок пока нет",
    "camp_f_title": "Название (внутреннее)",
    "camp_f_body": "Текст сообщения",
    "camp_f_image": "Картинка (URL, необяз.)",
    "camp_f_target": "Переход по кнопке",
    "camp_f_pick": "Куда вести",
    "camp_f_button": "Текст кнопки",
    "camp_btn_ph": "Открыть",
    "camp_f_audience": "Аудитория",
    "camp_target_none": "Без кнопки",
    "camp_target_product": "К товару",
    "camp_target_category": "К категории",
    "camp_aud_all": "Все",
    "camp_send": "📣 Отправить рассылку",
    "camp_sending": "Отправка…",
    "camp_sent": "Отправлено: {{sent}}, ошибок: {{failed}}",
    "camp_stats": "Отправлено: {{sent}} · ошибок: {{failed}}",
    "camp_save_first": "Сначала сохраните, затем появится кнопка отправки",
    "camp_status_draft": "Черновик",
    "camp_status_sending": "Отправка",
    "camp_status_done": "Отправлено",
    "cancel": "Отмена",
    "promo_new": "+ Новая акция",
    "promo_empty": "Акций пока нет",
    "promo_inactive": "Выкл",
    "promo_pick_product": "Выберите товар",
    "promo_type_cart_total": "Скидка от суммы",
    "promo_type_day": "Скидка в день недели",
    "promo_type_product_buy": "Скидка при покупке товара",
    "promo_type_bonus_item": "Бонус-товар",
    "promo_reward_percent": "Процент %",
    "promo_reward_fixed": "Сумма",
    "promo_f_title": "Название",
    "promo_f_code": "Промокод (пусто = авто)",
    "promo_code_ph": "напр. SALE10 (пусто — применять всем)",
    "promo_f_type": "Тип акции",
    "promo_f_min_total": "Сумма корзины от",
    "promo_f_min_total_opt": "Мин. сумма (необяз.)",
    "promo_f_weekdays": "Дни недели",
    "promo_f_trigger_product": "Товар-триггер",
    "promo_f_min_qty": "Мин. количество",
    "promo_f_reward_kind": "Скидка",
    "promo_f_reward_value": "Значение",
    "promo_f_bonus_product": "Бонус-товар",
    "promo_f_bonus_name": "Название бонуса",
    "promo_f_bonus_qty": "Кол-во бонуса",
    "promo_f_starts": "Начало",
    "promo_f_ends": "Конец",
    "promo_f_priority": "Приоритет",
    "promo_f_active": "Активна",
    "promo_f_stackable": "Суммируется",
    "wd_0": "Вс",
    "wd_1": "Пн",
    "wd_2": "Вт",
    "wd_3": "Ср",
    "wd_4": "Чт",
    "wd_5": "Пт",
    "wd_6": "Сб",
    "returns_empty": "Заявок на возврат нет",
    "mod_banners": "Баннеры",
    "mod_banners_hint": "Промо-баннеры на главной",
    "mod_pickup": "Пункты выдачи",
    "mod_pickup_hint": "Точки самовывоза",
    "mod_categories": "Категории",
    "mod_categories_hint": "Категории каталога",
    "mod_dictionary": "Справочники",
    "mod_dictionary_hint": "Размеры, цвета, бренды, бейджи",
    "mod_products": "Товары",
    "mod_products_hint": "Товары и цены",
    "mod_settings": "Настройки",
    "mod_settings_hint": "Контакты, доставка, реквизиты",
    "mod_users": "Пользователи",
    "mod_users_hint": "Роли и блокировка",
    "mod_analytics": "Аналитика",
    "mod_analytics_hint": "Заказы, выручка, визиты",
    "no_orders": "Заказов пока нет",
    "customer": "Клиент",
    "change_status": "Статус",
    "status_updated": "Статус обновлён",
    "courier": "Курьер",
    "courier_none": "Без курьера",
    "courier_assigned": "Курьер назначен",
    "car_model": "Модель",
    "car_color": "Цвет",
    "car_plate": "Номер",
    "fulfill_title": "Отметка доставки",
    "fulfill": "Подтвердить доставку",
    "fulfilling": "Сохранение…",
    "fulfill_hint": "Укажите фактически переданное количество. Недоставленное вернётся на склад, сумма пересчитается.",
    "fulfill_locked": "Доступно только для статусов «Собран» / «В доставке».",
    "ordered_q": "заказано",
    "mark_delivery": "Отметить доставку",
    "photos": "Фото",
    "photos_title": "Фото товара",
    "photos_upload": "+ Загрузить фото",
    "photos_uploading": "Загрузка…",
    "photos_empty": "Фото пока нет",
    "photos_main": "Главное",
    "photos_set_main": "Сделать главным"
  },
  "checkout": {
    "items": "Товары ({count})",
    "delivery": "Доставка",
    "free": "бесплатно",
    "discount": "Скидка",
    "bonus": "Подарок",
    "promo_placeholder": "Промокод",
    "promo_applied": "применён",
    "total": "Итого",
    "clear": "Очистить",
    "page_title": "Оформление заказа",
    "section_contact": "Контактные данные",
    "section_delivery": "Способ получения",
    "section_payment": "Оплата",
    "section_notes": "Комментарий к заказу",
    "name_label": "Имя получателя",
    "phone_label": "Телефон",
    "phone_share_cta": "Поделиться номером",
    "phone_unavailable": "Эта функция доступна только в Telegram",
    "address_label": "Улица, дом, квартира",
    "address_placeholder": "ул. Примерная, 1, кв. 25",
    "city_label": "Город",
    "city_placeholder": "Ташкент",
    "postal_label": "Индекс",
    "postal_placeholder": "100000",
    "pickup_select": "Выберите пункт выдачи",
    "pickup_empty": "Нет доступных пунктов выдачи",
    "pickup_main_badge": "Главный",
    "notes_placeholder": "Пожелания по заказу (необязательно)",
    "place_order": "Подтвердить заказ",
    "placing": "Отправляем...",
    "order_created": "Заказ оформлен",
    "back_to_cart": "← В корзину",
    "continue_to_checkout": "К оформлению",
    "empty_cart": "В корзине пусто",
    "err_required_name": "Укажите имя получателя",
    "err_required_phone": "Укажите телефон",
    "err_required_pickup": "Выберите пункт выдачи",
    "err_required_address": "Укажите адрес доставки",
    "err_required_city": "Укажите город",
    "order_summary": "Ваш заказ",
    "section_date": "Дата доставки",
    "date_today": "Сегодня",
    "date_tomorrow": "Завтра",
    "date_change": "Изменить",
    "recipient_me": "Я получаю",
    "recipient_other": "Оформить на другого",
    "section_recipient": "Данные получателя",
    "recipient_fio_label": "ФИО получателя",
    "recipient_fio_placeholder": "Иванов Иван Иванович",
    "recipient_phone_label": "Телефон получателя",
    "share_location_cta": "Поделиться геолокацией",
    "location_hint": "Адрес можно будет изменить после заполнения",
    "address_map_hint": "Поставьте метку на карте или впишите адрес. Домофон/ориентир — в примечании к заказу.",
    "location_unavailable": "Эта функция доступна только в Telegram",
    "payer_me": "Оплачу я",
    "payer_recipient": "Оплатит получатель",
    "payer_hint": "Способ оплаты — наличными при получении"
  },
  "profile": {
    "title": "Профиль",
    "default_name": "Пользователь",
    "telegram_id": "Telegram ID",
    "language": "Язык",
    "premium": "Premium",
    "platform": "Платформа",
    "sdk_version": "Версия SDK",
    "edit_name": "Изменить имя",
    "first_name": "Имя",
    "last_name": "Фамилия",
    "save": "Сохранить",
    "saved": "Сохранено",
    "share_phone": "Поделиться номером",
    "phone_set": "Номер сохранён",
    "phone_empty": "Не указан",
    "phone_unavailable": "Эта функция доступна только в Telegram",
    "share_location": "Поделиться геолокацией",
    "location_set": "Локация сохранена",
    "location_empty": "Не указана",
    "location_unavailable": "Эта функция доступна только в Telegram",
    "tg_source_note": "Аватар и имя подтянуты из Telegram. Их можно изменить здесь.",
    "photo_bad_type": "Выберите изображение (JPEG, PNG или WebP)",
    "photo_too_large": "Файл слишком большой — максимум 5 МБ",
    "photo_uploaded": "Фото успешно загружено",
    "photo_upload_error": "Не удалось загрузить фото",
    "about_store": "О магазине",
    "about_store_hint": "Адрес, контакты и юридическая информация",
    "menu_orders": "Мои заказы",
    "menu_orders_hint": "История заказов и статусы",
    "menu_addresses": "Мои адреса",
    "menu_addresses_hint": "Адрес доставки на карте",
    "menu_favorites": "Избранное",
    "menu_favorites_hint": "Сохраненные товары",
    "menu_cart": "Корзина",
    "menu_cart_hint": "Товары к оформлению",
    "menu_delivery": "Доставка и оплата",
    "menu_delivery_hint": "Условия доставки и способы оплаты",
    "menu_return": "Возврат и обмен",
    "menu_return_hint": "Правила возврата и обмена товара",
    "menu_support": "Поддержка",
    "menu_support_hint": "Связаться с нами по вопросам заказа",
    "menu_channel": "Перейти на наш канал",
    "menu_channel_hint": "Новости, поступления и обновления"
  },
  "contacts": {
    "title": "О магазине",
    "store_name": "Магазин",
    "address": "Адрес",
    "open_in_maps": "Открыть в картах",
    "copy_address": "Скопировать адрес",
    "copied": "✓ Скопировано",
    "copy_failed": "Не удалось скопировать",
    "support": "Служба поддержки",
    "phone": "Телефон",
    "email": "Электронная почта",
    "telegram": "Telegram",
    "legal": "Юридическая информация",
    "legal_name": "Название",
    "legal_inn": "ИНН",
    "legal_address": "Юридический адрес"
  },
  "splash": {
    "brand": "EUROSTYLE"
  },
  "pickup_code": {
    "show_to_courier": "Покажите курьеру на пункте выдачи",
    "code_label": "Код заказа",
    "qr_alt": "QR-код заказа",
    "scan_hint": "Курьер отсканирует QR или введёт код вручную — после этого заказ будет отмечен как доставленный.",
    "invalid": "Некорректный код"
  },
  "addresses": {
    "title": "Мои адреса",
    "delivery_address": "Адрес доставки",
    "placeholder": "Город, улица, дом",
    "save": "Сохранить",
    "saving": "Сохранение…",
    "saved": "Адрес сохранён",
    "hint": "Поставьте метку на карте или впишите адрес. Домофон/ориентир — в примечании к заказу."
  },
  "orders": {
    "title": "Мои заказы",
    "empty": "У вас пока нет заказов",
    "empty_hint": "Оформите первый заказ в каталоге"
  },
  "order": {
    "title": "Заказ #{short_id}",
    "not_found": "Заказ не найден",
    "status_new": "Новый",
    "status_packed": "Собран",
    "status_delivering": "Доставляется",
    "status_delivered": "Доставлен",
    "status_partial": "Доставлен частично",
    "status_cancelled": "Отменён",
    "delivery_pickup": "Самовывоз",
    "delivery_courier": "Курьер",
    "address": "Адрес доставки",
    "pickup_point": "Пункт выдачи",
    "courier": "Курьер",
    "open_in_maps": "Открыть в картах",
    "call_phone": "Позвонить",
    "items_count": "{count, plural, one {# товар} few {# товара} many {# товаров} other {# товаров}}",
    "subtotal": "Товары",
    "shipping": "Доставка",
    "total": "Итого",
    "ordered_at": "Оформлен {date}",
    "verified_at": "Получен {date}",
    "delivery_code_hint": "Покажите код курьеру"
  },
  "courier": {
    "title": "Мои доставки",
    "profile_hint": "Назначенные заказы и подтверждение",
    "code_label": "Код получения от клиента",
    "code_placeholder": "XXXXXXXX",
    "confirm": "Подтвердить доставку",
    "confirming": "Подтверждаю…",
    "confirmed": "Доставка подтверждена ✓",
    "empty": "Нет назначенных доставок",
    "call": "Позвонить",
    "maps": "На карте"
  },
  "returns": {
    "request": "Оформить возврат",
    "requested_ok": "Заявка на возврат отправлена",
    "reason_placeholder": "Причина возврата (необязательно)",
    "ordered": "заказано: {count}",
    "submit": "Отправить заявку",
    "sending": "Отправка…",
    "reason": "Причина",
    "approve": "Одобрить",
    "reject": "Отклонить",
    "mark_received": "Принять (на склад)",
    "status_requested": "Запрошен",
    "status_approved": "Одобрен",
    "status_received": "Принят",
    "status_rejected": "Отклонён"
  },
  "errors": {
    "network": "Нет соединения. Проверьте интернет.",
    "internal": "Что-то пошло не так. Попробуйте ещё раз.",
    "db": "Ошибка базы данных.",
    "validation": "Некорректные данные.",
    "forbidden": "Доступ запрещён.",
    "not_found": "Не найдено.",
    "banned": "Аккаунт заблокирован.",
    "no_user": "Пользователь не найден.",
    "init_data_invalid": "Ошибка авторизации Telegram.",
    "init_data_missing": "Откройте приложение из Telegram.",
    "invalid_state": "Недопустимый статус заказа.",
    "storage": "Ошибка загрузки файла.",
    "invalid_file_type": "Неподдерживаемый формат файла.",
    "invalid_file_size": "Файл слишком большой.",
    "invalid_phone": "Некорректный номер телефона.",
    "stock": "Недостаточно товара на складе."
  }
}
